import { ChannelsNames } from 'modules/application/detail/channels/Channels';
export class ProfileCommandProcessor {
    static $inject = ['MessagingHubService', 'FacebookProfileCommandProcessor'];
    constructor(MessagingHubService, FacebookProfileCommandProcessor) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.FacebookProfileCommandProcessor = FacebookProfileCommandProcessor;
    }
    async sendProfileCommand(application, method, profileId, type, resource) {
        try {
            if (method == 'set' || method == 'delete') {
                await Promise.all([
                    this.FacebookProfileCommandProcessor.sendProfileCommand(application, method, profileId, type, resource),
                    this.FacebookProfileCommandProcessor.sendProfileCommand(application, method, profileId, type, resource, 'postmaster@workplace.gw.msging.net', ChannelsNames.Workplace),
                ]);
            }
            const command = {
                method: method,
                uri: `/profile/${profileId}`,
            };
            if (method == 'set' && type && resource) {
                command.type = type;
                command.resource = resource;
            }
            const result = await this.MessagingHubService.sendCommand(command);
            if (method == 'get') {
                return result;
            }
        }
        catch (e) {
            if (e.code == 67) {
                return undefined;
            }
            throw e;
        }
    }
}
ProfileCommandProcessor.$inject = ['MessagingHubService', 'FacebookProfileCommandProcessor'];
